import { Box, Toast } from "@prismicio/editor-ui"
import type { Editor } from "@tiptap/core"
import { useEffect, useState } from "react"

import { useEditorConfig } from "../../../../EditorConfig"
import { TableEvent } from "./TableEvent"

interface LimitModalProps {
  editor: Editor
}

export function TableLimitToast(props: LimitModalProps) {
  const { editor } = props
  const { open, onOpenChange } = useTableLimitToastState(editor)

  return (
    <Toast
      title="You've reached the limit (50 rows / 25 columns)."
      action={{
        title: "Need more?",
        onClick: () =>
          window.open(
            "https://community.prismic.io/t/how-should-the-table-field-evolve-your-call/18542",
            "_blank",
          ),
      }}
      open={open}
      onOpenChange={onOpenChange}
      anchor={<Box position="fixed" left={0} right={0} bottom={72} />}
      cancel={{
        onClick: () => onOpenChange(false),
      }}
    />
  )
}

function useTableLimitToastState(editor: Editor) {
  const [open, onOpenChange] = useState(false)
  const { onAnalyticsEvent } = useEditorConfig()

  useEffect(() => {
    // Listen to the add row/column click events and open the menu.
    return TableEvent.listen("addAtLimit", {
      editor,
      callback: (detail) => {
        onAnalyticsEvent?.("Table Limit Reached", { type: detail.type })
        onOpenChange(true)
      },
    })
  }, [editor, onAnalyticsEvent])

  return { open, onOpenChange }
}
